<script setup lang="ts">
import { SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import { colorHex } from "@/lib/colors"
import { pluralize } from "@/lib/format"
import { ICON, lucideIcon } from "@/lib/icons"
import { itemTypePath } from "@/routes"
import type { ItemTypeSummary } from "@/types/models"

defineProps<{ itemType: ItemTypeSummary }>()
</script>

<template>
  <SbListItem :to="itemTypePath({ id: itemType.id })">
    <SbListSection avatar>
      <UIcon
        :name="lucideIcon(itemType.icon_class)"
        class="size-5"
        :style="{ color: colorHex(itemType.color_class) }"
      />
    </SbListSection>
    <SbListSection>
      <SbListLabel :class="{ 'text-muted': !itemType.active }">
        {{ itemType.display_name }}
      </SbListLabel>
      <SbListLabel caption>{{ pluralize(itemType.items_count, "item") }}</SbListLabel>
    </SbListSection>
    <SbListSection side>
      <div class="flex items-center gap-2">
        <UBadge v-if="!itemType.active" color="neutral" variant="subtle" size="sm">
          Inactive
        </UBadge>
        <UIcon :name="ICON.chevronRight" class="size-4" />
      </div>
    </SbListSection>
  </SbListItem>
</template>
